import { useParams, useSearchParams } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';

import { EventPublicInfo } from 'src/types/dto';
import { RouteParamsEvent } from 'src/types/routing';

const useEventData = () => {
  const queryClient = useQueryClient();
  const { eventID } = useParams<RouteParamsEvent>();
  const [searchParams] = useSearchParams();
  const privateLinkName = searchParams.get('linkname');
  
  //eventinfo
  return queryClient.getQueryData<EventPublicInfo>(['event', privateLinkName ? `${eventID}?linkname=${privateLinkName}` : eventID]);
};

export default useEventData;
